export const SORA_REMIX_MODEL_KEY = 'sora-2-async-remix' as const;
